import gsap from "gsap";
const facilitiesAccordion = document.querySelectorAll(
  "section.facilities-accordion"
);
facilitiesAccordion.forEach((facilitiesAccordion) => {
  const imgTag = facilitiesAccordion.querySelector("img.facility-img");
  const accordionItems =
    facilitiesAccordion.querySelectorAll(".accordion-item");
  accordionItems.forEach((accordionItem) => {
    accordionItem.addEventListener("click", () => {
      if (accordionItem.classList.contains("active")) {
        return;
      }
      const imgUrl = accordionItem.dataset.img;
      console.log(imgUrl)
      
      // Create a timeline for smooth image transition
      const tl = gsap.timeline();
      
      tl.to(imgTag, {
        opacity: 0,
        duration: 0.25,
        ease: "power2.inOut",
        onComplete: () => {
          // Change the image source when fade out is complete
          imgTag.src = imgUrl;
        }
      })
      .to(imgTag, {
        opacity: 1,
        duration: 0.25,
        ease: "power2.inOut"
      });
      accordionItems.forEach((item) => {
        if (item !== accordionItem) {
          item.classList.remove("active");
        } else {
          item.classList.add("active");
        }
      });
    });
  });
});
